import { HttpRequestData, httpUtil, PaginationResponse } from '@esg/framework';
import { getEnv, PaginationRequest } from '@esg/shared';

interface GetOrganizationsRequest extends HttpRequestData {
    readonly query: PaginationRequest & {
        startTime?: string;
        endTime?: string;
    };
}

export interface OrganizationItem {
    id: string;
    name: string;
    contactEmail: string | null;
}

export const getOrganizations = httpUtil.createHttpRequestMeta<
    GetOrganizationsRequest,
    PaginationResponse<OrganizationItem>
>({
    baseUrl: () => getEnv().AGENCY_SERVER,
    path: '/api/v1/organizations',
    method: 'GET',
    authentication: 'bearer',
});